module.exports = __webpack_public_path__ + "img/win1.5099ee3a.png";